var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCargas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.602 1.1a.863.863 0 011.069-.075l.092.075 9.47 8.693a.78.78 0 01.02 1.142.853.853 0 01-.49.235l-.111.007h-1.134v9.38c0 .377-.27.692-.632.78l-.102.018-.105.006h-4.997a.828.828 0 01-.833-.703l-.006-.1-.001-5.308h-3.32v5.307c0 .377-.269.692-.632.78l-.101.018-.105.006H3.686a.828.828 0 01-.832-.703l-.007-.1v-9.381H1.714a.834.834 0 01-.813-.605l-.02-.097-.006-.101c0-.183.065-.36.182-.5l.077-.081L10.602 1.1zm.581.75l-9.149 8.398h.938c.427 0 .78.306.833.703l.006.101v9.38h4.747l.001-5.306c0-.411.321-.748.734-.798l.105-.006h3.57c.426 0 .78.305.832.703l.007.1-.001 5.307h4.748v-9.38c0-.41.322-.748.734-.797l.105-.006.941-.001-9.151-8.398z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCargas);
export default __webpack_public_path__ + "static/media/icon_cargas.c16b85ab8b49f5c18b96240c76e07e7d.svg";
export { ForwardRef as ReactComponent };